var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs-container"},[_c('JobsPageBuilder',{attrs:{"response":_vm.response,"vacancies":_vm.vacancies,"jobsCardTranslations":_vm.jobsCardTranslations,"jobsFromWorkable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }